import { render, staticRenderFns } from "./sycase.vue?vue&type=template&id=bed1361c&"
import script from "./sycase.vue?vue&type=script&lang=js&"
export * from "./sycase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports